import styled from "styled-components"

export default styled.div`
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 4%);
  background-color: ${(props) => props.theme.palette.background.paper};
`
